export default class ButtonSimple extends Phaser.Button {
  constructor({ game, x = 0, y = 0, up, over, atlas = 'ui_buttons' }) {
    super(game, x, y, atlas);
    this.setFrames(over, up, up, up);
    this.anchor.set(0.5);

    this.data = {};
    this.out = up;
    this.over = over;
    this.isOver = false;
    this.input.useHandCursor = true;
    this.game.time.events.add(1, this.init, this);

    this.onInputDown.add(this.onDown, this);
    this.onInputOver.add(this.onOver, this);
    this.onInputOut.add(this.onOut, this);
  }

  init() {
    if (this.game) {
      const mx = this.game.input.activePointer.x;
      const my = this.game.input.activePointer.y;
      if (this.isWithinBounds(mx, my)) {
        // this.onOver();
      } else {
        // this.onOut();
      }
    }
    this.enable();
  }

  enable() {
    this.input.enabled = true;
  }

  disable() {
    this.input.enabled = false;
  }

  isWithinBounds(x, y) {
    return this.getBounds().contains(x, y);
  }

  onOver() {
    this.isOver = true;
    this.scale.set(1.1);
  }

  onOut() {
    this.isOver = false;
    this.scale.set(1);
  }

  onDown() {
    this.scale.set(1.15);
    this.game.sounds.playSFX('click', { spriteID: 'sfx_gameplay' });
  }

  pulse(repeat) {
    this.pulseTween = this.game.add
      .tween(this.scale)
      .to({ x: [1.2, 1], y: [1.2, 1] }, 800, Phaser.Easing.BackOut, true, 0, repeat);
  }

  stopPulse() {
    if (this.pulseTween) {
      this.pulseTween.stop();
      this.pulseTween = false;
    }
  }

  destroy() {
    this.onInputDown.removeAll();
    this.onInputOver.removeAll();
    this.onInputOut.removeAll();
    this.disable();
    super.destroy();
  }
}
